import { COLORS, STYLES } from "@constants";
import RcSlider from "rc-slider";
import styled from "styled-components";

interface Props {
  range?: boolean;
  vertical?: boolean;
  reverse?: boolean;
  value: number | number[];
  min: number;
  max: number;
  dots?: boolean;
  allowCross?: boolean;
  onChange?: (newRange: number | number[]) => void;
}

const SliderHandle = (handle: any) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <div {...handle.props} className="rc-slider-handle" data-testid="slider-handle">
    {sliderHandleIcon}
  </div>
);

const Slider = ({
  range = false,
  vertical = false,
  reverse = false,
  value,
  min,
  max,
  dots = false,
  allowCross = true,
  onChange,
}: Props) => {
  return (
    <SliderContainer $isRange={range}>
      <SliderTrackBackground />
      <RcSlider
        range={range}
        vertical={vertical}
        reverse={reverse}
        value={value}
        min={min}
        max={max}
        dots={dots}
        allowCross={allowCross}
        handleRender={SliderHandle}
        onChange={onChange}
      />
    </SliderContainer>
  );
};

export default Slider;

const SliderContainer = styled.div<{ $isRange: boolean }>`
  display: flex;
  align-items: center;
  position: relative;
  height: 408px;
  width: 24px;
  .rc-slider {
    height: 384px;
    width: 6px;
    padding: 0;
    left: 9px;
    cursor: pointer;
    .rc-slider-rail {
      width: 6px;
      left: 0;
      background-color: ${COLORS.NEUTRAL_200};
    }
    .rc-slider-track {
      background-color: ${(props) => (props.$isRange ? COLORS.HALO_BLUE : "transparent")};
      width: 6px;
      left: 0;
    }
    .rc-slider-step {
      width: 6px;
      .rc-slider-dot {
        width: 6px;
        height: 1px;
        margin: 0;
        border-radius: 0;
        border: none;
        background-color: ${COLORS.NEUTRAL_400};
      }
      .rc-slider-dot-active {
        background-color: ${(props) =>
          props.$isRange ? COLORS.NEUTRAL_200 : "rgb(156, 163, 175)"};
      }
    }
    .rc-slider-handle {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 24px;
      height: 24px;
      margin-left: -9px;
      border: none;
      box-shadow: ${STYLES.SHADOW_A};
      background-color: ${COLORS.WHITE};
      opacity: 1;
    }
  }
`;

const SliderTrackBackground = styled.div`
  position: absolute;
  left: 9px;
  width: 6px;
  height: 100%;
  background-color: ${COLORS.NEUTRAL_200};
  border-radius: 3px;
`;

const sliderHandleIcon = (
  <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 1L-4.17233e-07 1" stroke={COLORS.HALO_BLUE} strokeWidth="1.5" />
    <path d="M10 4L-4.17233e-07 4" stroke={COLORS.HALO_BLUE} strokeWidth="1.5" />
    <path d="M10 7L-4.17233e-07 7" stroke={COLORS.HALO_BLUE} strokeWidth="1.5" />
  </svg>
);
